import {AxiosResponse} from "axios";

import JsonApi from "../../api/jsonApi";
import {setAiRenderOptions, setGlobalSettingsRequested} from "./aiActions";
import {AppDispatch, RootState} from "../../storeHooks";
import {getCommonVisualizerType} from "../../config";

export const getAIGlobalSettings = () => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    const visualizerType = getCommonVisualizerType();
    if (getState().aiState.aiGlobalSettingsRequested.includes(visualizerType)) {
      return
    }
    try {
      const aiJson: AxiosResponse<{
        aiEnableThumbnailImages: boolean;
        aiEnableReferenceImage: boolean;
        aiSendCombinedThumbnails: boolean;
      }> = await JsonApi.getAIGlobalSettings();
      if (aiJson?.data) {
        dispatch(setAiRenderOptions({
          aiEnableReferenceImage: aiJson.data.aiEnableReferenceImage,
          aiEnableThumbnailImages: aiJson.data.aiEnableThumbnailImages,
          aiSendCombinedThumbnails: aiJson.data.aiSendCombinedThumbnails,
        }));
      }
      dispatch(setGlobalSettingsRequested(visualizerType));
    } catch (e) {
      dispatch(setGlobalSettingsRequested(visualizerType));
      console.log("geAIGlobalSettings error", e);
    }
  }
};
